export function extractDomainFromEmailAddress(email) {
  const parts = email.split('@');

  if (parts.length !== 2) {
    throw new Error('Invalid email address');
  }

  return parts[1];
}
